<template>
    <div>
       
       <main class="main">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <li><router-link to="/index"><a href="">首頁</a></router-link></li>
                        <li>下載App</li>
                    </ul>
                </div>
            </div>

            <!-- <div class="brand_head">
                <div class="container">
                    <div class="wrapper">
                        <h1 class="wow fadeInUp">品牌精神</h1>
                        <p class="wow fadeInUp">被光包覆著，眼睛看到世界的多彩與意象</p>
                        <p class="marginB_1 wow fadeInUp">也被聲波所包覆，在時間裏，耳朵感受到世界的心跳</p>
                        <p class="wow fadeInUp">手機是我身體的一部份，是我感受的延伸</p>
                        <p class="wow fadeInUp">我的生活零碎但必須精采，</p>
                        <p class="wow fadeInUp">一刻 15 分鐘的音頻，像晶瑩的氧氣氣泡，閃綴起海洋中的知識藍圖</p>
                        
                    </div>
                </div>
                <div class="image"><img src="images/graphic_ocean.jpg" alt=""></div>
            </div> -->

            <div class="bodyContent">

                <div class="downloadApp">
                    <div class="container row">
                        <div class="col">
                            <strong><img src="@/assets/images/logo_text.png" alt="一刻鯨選"></strong>
                            <div class="qrcode"><img src="@/assets/images/global_qrcode.png" alt="下載QRcode"></div>
                            <div class="stores">
                                <a href=""><img src="@/assets/images/appstore.png" title="從 App Store 下載"></a>
                               <a href="" onclick="window.open('https://play.google.com/store/apps/details?id=net.jinfm.app')"><img src="@/assets/images/googleplay.png" title="從 Google Play 下載"></a>
                            </div>
 <!--ios上架後移除 start-->
                            <p style="font-size: 13px; margin-top: -10px;">＊iOS版即將推出</p>
                            <!--ios上架後移除 end-->

                            <!-- <div class="otherdown">
                                <a class="btnStyle_download" href="#"><span>下載 APK 檔</span></a>
                            </div> -->
                        </div>
                        <div class="col">
                            <figure class="wow fadeInUp">
                                <img src="@/assets/images/deviceprev.png" alt="一刻鯨選裝置預覽圖">
                            </figure>
                        </div>
                    </div>
                </div>

            </div>


        </main>
      
    </div>    
</template>

<script>
export default {
    name: 'async',
    metaInfo () {
      return {
        
        title: '下載 App | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '下載 App | 一刻鯨選'},
            {property: 'og:site_name', content: '下載 App | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            // {property: 'og:image', content: '/static/logo.png'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！'},
        
        ]
      }
    },
    
 data() {
    return {
       classData: [],
    }
  },
 methods: {
       

        changePage(page){
        this.$router.push({ path: "/"+page});

        }

　　},
    mounted() {
        $( "body" ).removeClass('index');
      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Download.vue